<template>
  <v-app-bar
    flat
    height="110"
    color="transparent"
    style="width: 100%;"
  >
    <v-toolbar-title
      style="width: 130px; cursor: pointer"
      class="ml-0 pl-4"
    >
      <div>
        <v-img
          src="@/assets/branding/gcg_logo.png"
          contain
          height="30"
          @click="toggleLogo"
        />
      </div>
    </v-toolbar-title>

    <v-spacer />

    <div class="hidden-sm-and-down px-4">
      <v-img
        contain
        src="@/assets/branding/gcg_slogan.png"
        width="160"
      />
    </div>
  </v-app-bar>
</template>

<script>
export default {
  name: 'Header',

  methods: {
    toggleLogo() {
      this.$router.push({ name: 'login' });
    },
  },
};
</script>
